import { render } from "./TheMyCollectionItemListView.vue?vue&type=template&id=6379eaaa&scoped=true&ts=true"
import script from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"

import "./TheMyCollectionItemListView.vue?vue&type=style&index=0&id=6379eaaa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6379eaaa"]])

export default __exports__